import { render, staticRenderFns } from "./ChoiceSelector.vue?vue&type=template&id=38d72854"
import script from "./ChoiceSelector.vue?vue&type=script&lang=js"
export * from "./ChoiceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports